import Checkbox from "./Checkbox";
import StandardSubSettings from "./StandardSubSettings";

const VMASettings = ({ settings, saveSettings }) => {
  var localSettings = StandardSubSettings(settings, "VMA");
  var notification = localSettings.notification;

  return (
    <div>
      <Checkbox
        name="EnableNotification"
        text="Aktivera notiser vid VMA"
        def={notification}
        onChange={() => {
          notification = !notification;
          localSettings.notification = notification;
          saveSettings(localSettings);
        }}
      />
    </div>
  );
};
export default VMASettings;
